import { render, staticRenderFns } from "./addProcess.vue?vue&type=template&id=47254338&scoped=true&"
import script from "./addProcess.vue?vue&type=script&lang=js&"
export * from "./addProcess.vue?vue&type=script&lang=js&"
import style0 from "./addProcess.vue?vue&type=style&index=0&id=47254338&lang=css&"
import style1 from "./addProcess.vue?vue&type=style&index=1&id=47254338&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47254338",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\aihuz\\arbitration-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47254338')) {
      api.createRecord('47254338', component.options)
    } else {
      api.reload('47254338', component.options)
    }
    module.hot.accept("./addProcess.vue?vue&type=template&id=47254338&scoped=true&", function () {
      api.rerender('47254338', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/process/addProcess.vue"
export default component.exports